import React from "react";

const Loading = (props) => {
  return (
    <div className="text-center">
      <span className="loading-spinner-header"></span>
      <span className="loading-spinner-header"></span>
      <span className="loading-spinner-header"></span>
    </div>
  );
};

export default Loading;
